/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_TitleInputs */

const en_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create your account`)
};

const de_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konto erstellen`)
};

const fr_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer ton compte`)
};

const es_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cree su cuenta`)
};

const it_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea il tuo account`)
};

const nl_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maak je account aan`)
};

const pl_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utwórz swoje konto`)
};

const fi_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luo tilisi`)
};

const da_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opret din konto`)
};

const sv_auth_signup_title = /** @type {(inputs: Auth_Signup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skapa ditt konto`)
};

/**
* | output |
* | --- |
* | "Create your account" |
*
* @param {Auth_Signup_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const auth_signup_title = /** @type {((inputs?: Auth_Signup_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_signup_title(inputs)
	if (locale === "fr") return fr_auth_signup_title(inputs)
	if (locale === "es") return es_auth_signup_title(inputs)
	if (locale === "it") return it_auth_signup_title(inputs)
	if (locale === "nl") return nl_auth_signup_title(inputs)
	if (locale === "pl") return pl_auth_signup_title(inputs)
	if (locale === "fi") return fi_auth_signup_title(inputs)
	if (locale === "da") return da_auth_signup_title(inputs)
	if (locale === "sv") return sv_auth_signup_title(inputs)
	return en_auth_signup_title(inputs)
});